const optionIsPartOf = (configuration) => (option) =>
  configuration.some(
    ({ attribute_id, value }) =>
      attribute_id === option.id && value === option.value
  );

const filterConfigurations = (configurations, selectedOptions) => {
  return configurations.filter(
    ({ configuration, product }) =>
      product &&
      Object.keys(selectedOptions)
        .map((key) => ({ id: key, value: selectedOptions[key] }))
        .every(optionIsPartOf(configuration))
  );
};

export default filterConfigurations;
